import React from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { MobileHeader } from './MobileHeader'
import { BottomNav } from './BottomNav'
import { useSidebarStore } from '@/shared/store/sidebarStore'
import { ExperienceEngine } from '@/platform/experiences/core/ExperienceEngine'
import styles from './AppShell.module.css'

/**
 * Application shell — the root layout for all authenticated pages.
 *
 * Responsive behavior:
 * - Mobile (< 768px):
 *     MobileHeader (top) → Main Content (scrollable) → BottomNav (fixed bottom)
 *     Sidebar is hidden; touch targets >= 44px; safe area insets respected.
 * - Desktop (>= 768px):
 *     Persistent collapsible Sidebar (left) + Desktop Header (top) + Main Content (right)
 */
export function AppShell() {
  const isCollapsed = useSidebarStore((s) => s.isCollapsed)

  return (
    <div
      className={styles.shell}
      data-sidebar-collapsed={isCollapsed}
    >
      {/* Desktop Persistent Sidebar (hidden on mobile via CSS) */}
      <Sidebar />

      <div className={styles.main}>
        {/* Mobile Top Header (< 768px) */}
        <MobileHeader />

        {/* Desktop Top Header (>= 768px) */}
        <div className={styles.desktopHeaderWrap}>
          <Header />
        </div>

        {/* Scrollable Main Content Area */}
        <main className={styles.content}>
          <div className={styles.contentInner}>
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation Bar (< 768px) */}
      <BottomNav />

      {/* Platform-wide Experience Engine portal */}
      <ExperienceEngine />
    </div>
  )
}
